import { ORIGIN } from "../config";

/** Resolve relative upload paths or absolute S3/http URLs for display. */
export const resolveMediaUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${ORIGIN || ""}${path}`;
};
